// /helpers/schedule/threeSync.js
// side-effects into WebGL viewer: set mesh appearance for timeline states

const getMeshObj = (viewer, meshId) => {
  try {
    return viewer?.meshesObject?.get(meshId) || null;
  } catch {
    return null;
  }
};

const setMaterialState = (material, state) => {
  if (!material) return;
  try {
    if (state === 'past') {
      material.transparent = false;
      material.opacity = 1;
      if ('emissive' in material) material.emissive.setHex(0x000000);
    } else if (state === 'future') {
      material.transparent = true;
      material.opacity = 0.2;
      if ('emissive' in material) material.emissive.setHex(0x000000);
    } else if (state === 'current') {
      material.transparent = false;
      material.opacity = 1;
      if ('emissive' in material) material.emissive.setHex(0xFFD166); // warm glow
    }
    material.needsUpdate = true;
  } catch {
    // noop
  }
};

const applyToObject3D = (obj, state) => {
  if (!obj) return;
  if (Array.isArray(obj.material)) obj.material.forEach(m => setMaterialState(m, state));
  else setMaterialState(obj.material, state);

  if (obj.children && obj.children.length) {
    obj.children.forEach(ch => applyToObject3D(ch, state));
  }
};

export const setMeshState = (viewer, meshId, state) => {
  const obj = getMeshObj(viewer, meshId);
  if (!obj) return;
  applyToObject3D(obj, state);
};

export const bulkSetState = (viewer, meshIds, state) => {
  (meshIds || []).forEach(id => setMeshState(viewer, id, state));
};

// main entry: sync scene for a given date using your current tasks
export const syncSceneForDate = (viewer, tasks, date) => {
  if (!viewer || !Array.isArray(tasks)) return;

  // collect meshIds by state
  const past   = new Set();
  const curr   = new Set();
  const future = new Set();

  tasks.forEach(t => {
    if (!t.meshIds || !t.startDate || !t.endDate) return;
    const s = +t.startDate, e = +t.endDate, now = +date;
    const state = (now < s) ? 'future' : (now > e) ? 'past' : 'current';
    t.meshIds.forEach(id => {
      if (state === 'past') past.add(id);
      else if (state === 'current') curr.add(id);
      else future.add(id);
    });
  });

  // apply states (order: future -> past -> current to ensure glow wins)
  bulkSetState(viewer, Array.from(future), 'future');
  bulkSetState(viewer, Array.from(past),   'past');
  bulkSetState(viewer, Array.from(curr),   'current');
};
